import React from "react";
import EditIcon from "@mui/icons-material/Edit";
import ClearIcon from "@mui/icons-material/Clear";
import Box from "@mui/material/Box";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import AddIcon from "@mui/icons-material/Add";
import axios from "axios";
import SweetAlert from "react-bootstrap-sweetalert";
import Pagination from "../../Pagination/Pagination";
import { useAppContext } from "../../Lib/ContextLib";
import { API_URL } from "../../config";
import Loader from "../Loader/Loader";
import EmptyState from "../../Components/EmptyState";
import moment from "moment";

export default function SpinWheel() {
  
  const { showPage, setShowPage, accessObject } = useAppContext();
  const { socket } = useAppContext();
  const [alert, setAlert] = React.useState(null);
  const [tableData, setTableData] = React.useState([]);
  const [searchSubType] = React.useState();
  const [rowValue, setRowValue] = React.useState();
  const [openValue, setOpenValue] = React.useState(0);
  const [loader, setLoader] = React.useState(false);
  const [searchTourName, setSearchTourName] = React.useState();
  const [buttonLoader, setButtonLoader] = React.useState(false);
  const [showPrePage] = React.useState(10);
  const [pagination, setPagination] = React.useState({
    start: 0,
    end: showPrePage,
  });

  React.useEffect(() => {
    getBranch();
  }, []);

  const onPaginationChange = (start, end) => {
    setPagination({ start: start, end: end });
  };

  const LoginSchema = Yup.object().shape({
    coin: Yup.number().required("required"),
    bonus: Yup.number().required("required"),
    amount: Yup.number().required("required"),
    status: Yup.string().required("required"),
    name: Yup.string().required("required"),
  });

  const getBranch = () => {
    setLoader(true);
    axios(`${API_URL}/api/coin-package/get-coin-package`, {
      method: "GET",
      credentials: "include",
    })
      .then((response) => {
        setLoader(false);

        setTableData(response.data.message);
      })
      .catch((error) => {
        console.log("getBranch error :::", error);
      });
  };

  const searchingData = [];
  let data = [];
  console.log("tableData 111 ---", tableData, searchTourName);
  if (searchTourName) {
    console.log("tableData 222 ---", tableData, tableData.length > 0);
    data = tableData.filter((item) => {
      return Object.values(item?.email).join("").includes(searchTourName);
    });
    console.log("data 111 ---", data);
    data?.map((dataItem) => searchingData.push(dataItem));
  } else {
    tableData.map((dataItem) => searchingData.push(dataItem));
  }

  const clickEditButton = (item) => {
    setShowPage(true);
    console.log("item edit value :::", item);
    setRowValue(item);
    setOpenValue(2);
  };

  const openAddTournament = (value) => {
    setRowValue();
    console.log("openAddTournament :::", value);
    setShowPage(true);
    setOpenValue(value);
  };

  const updateTournament = (value) => {
    console.log("updateTournament value :::", value);
    const data = { ...value, id: rowValue._id };
    console.log("data :::", data);
    axios
      .post(`${API_URL}/api/coin-package/update-coin-package`, data)
      .then((res) => {
        console.log("update :::", res.data);

        if (res.data.isValid) {
          setButtonLoader(false);
          socket.emit("coinPackageUpdate");
          successEdit(res.data.message);
        }
      })
      .catch((err) => {
        console.log("update err :::", err);
        setButtonLoader(false);
      });
  };

  const addNewTournament = (value) => {
    console.log("addNewTournament value :::", value, openValue, rowValue);
    axios(`${API_URL}/api/coin-package/add-coin-package`, {
      method: "POST",
      credentials: "include",
      data: value,
    })
      .then((result) => {
        console.log("handleSubmit result :::", result.data);
        if (result.data.isValid) {
          setButtonLoader(false);
          socket.emit("coinPackageAdd");
          successAdd(result.data.message);
        }
      })
      .catch((err) => {
        console.log("handleSubmit err :::", err);
      });
  };

  const warningWithConfirmMessage = (e) => {
    setAlert(
      <SweetAlert
        custom
        showCancel
        confirmBtnText="Yes, Delete"
        cancelBtnText="Cancel"
        confirmBtnBsStyle="danger"
        cancelBtnBsStyle="default"
        onConfirm={() => {
          deleteData(e);
          setAlert(null);
        }}
        onCancel={() => setAlert(null)}
        customClass="premium-alert" btnSize="md" title=""
        confirmBtnClass="premium-alert-confirm bg-danger shadow-danger"
        cancelBtnClass="premium-alert-cancel"
        customIcon={<div className="mb-4" style={{ fontSize: '50px', color: '#dc3545' }}><i className="fas fa-trash-alt"></i></div>}
      >
        <div className="premium-alert-title">Are you sure?</div>
        <p className="premium-alert-text">You are about to delete this coin package. This action cannot be undone.</p>
      </SweetAlert>
    );
  };

  const successDeleted = (msg) => {
    setAlert(
      <SweetAlert
        success
        onConfirm={() => {
          getBranch();
          setAlert(null);
        }}
        customClass="premium-alert" btnSize="md" title=""
        confirmBtnClass="premium-alert-confirm"
      >
        <div className="premium-alert-title">Deleted!</div>
        <p className="premium-alert-text">{msg || "The coin package has been successfully removed."}</p>
      </SweetAlert>
    );
  };

  const deleteData = (e) => {
    console.log("e===>", e._id);
    const data = { id: e._id };
    axios
      .post(`${API_URL}/api/coin-package/delete-coin-package`, data)
      .then((res) => {
        console.log(res);
        console.log(res.data);
        if (res.data.isValid) {
          successDeleted(res.data.message);
          socket.emit("coinPackageDelete");
        }
        getBranch();
      });
  };

  const successAdd = (msg) => {
    setAlert(
      <SweetAlert
        success
        onConfirm={() => {
          getBranch();
          setAlert(null);
          setShowPage(false);
        }}
        customClass="premium-alert" btnSize="md" title=""
        confirmBtnClass="premium-alert-confirm"
      >
        <div className="premium-alert-title">Success!</div>
        <p className="premium-alert-text">{msg || "The coin package has been added successfully."}</p>
      </SweetAlert>
    );
  };

  const successEdit = (msg) => {
    setAlert(
      <SweetAlert
        success
        onConfirm={() => {
          getBranch();
          setAlert(null);
          setShowPage(false);
        }}
        customClass="premium-alert" btnSize="md" title=""
        confirmBtnClass="premium-alert-confirm"
      >
        <div className="premium-alert-title">Updated!</div>
        <p className="premium-alert-text">{msg || "The coin package has been updated successfully."}</p>
      </SweetAlert>
    );
  };

  return (
    <>
      {alert}
      {showPage ? (
        <div class="content p-3 ">
          <div className="card p-3">
            <Box sx={{ width: "100%" }}>
              <Formik
                initialValues={{
                  name: rowValue ? rowValue?.name : "",
                  coin: rowValue ? rowValue?.coin : "",
                  bonus: rowValue ? rowValue?.bonus : "",
                  amount: rowValue ? rowValue?.amount : "",
                  status: rowValue ? rowValue?.status : "",
                }}
                validationSchema={LoginSchema}
                onSubmit={(values) => {
                  setButtonLoader(true);
                  console.log("update formik value :::", values, openValue);
                  if (openValue == 1) {
                    console.log("update formik value :::", openValue);
                    addNewTournament(values);
                  }
                  if (openValue == 2) {
                    console.log("update formik value :::", openValue);
                    updateTournament(values);
                  }
                }}
              >
                {({ touched, errors, values }) => (
                  <Form>
                    <div className="row">
                      {/* Name & Status */}
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Package Name <span className="text-danger">*</span></label>
                          <Field
                            type="text"
                            name="name"
                            placeholder="e.g. Starter Pack"
                            className={`mt-1 form-control ${touched.name && errors.name ? "is-invalid" : ""}`}
                          />
                          <ErrorMessage component="div" name="name" className="invalid-feedback" />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Status <span className="text-danger">*</span></label>
                          <Field
                            as="select"
                            name="status"
                            className={`mt-1 form-control ${touched.status && errors.status ? "is-invalid" : ""}`}
                          >
                            <option value="">Select Status</option>
                            <option value="on">Active (ON)</option>
                            <option value="off">Inactive (OFF)</option>
                          </Field>
                          <ErrorMessage component="div" name="status" className="invalid-feedback" />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      {/* Coin & Bonus */}
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Coins <span className="text-danger">*</span></label>
                          <Field
                            type="number"
                            name="coin"
                            placeholder="0"
                            className={`mt-1 form-control ${touched.coin && errors.coin ? "is-invalid" : ""}`}
                          />
                          <ErrorMessage component="div" name="coin" className="invalid-feedback" />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Bonus Coins <span className="text-danger">*</span></label>
                          <Field
                            type="number"
                            name="bonus"
                            placeholder="0"
                            className={`mt-1 form-control ${touched.bonus && errors.bonus ? "is-invalid" : ""}`}
                          />
                          <ErrorMessage component="div" name="bonus" className="invalid-feedback" />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      {/* Amount */}
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Price Amount (₹) <span className="text-danger">*</span></label>
                          <Field
                            type="number"
                            name="amount"
                            placeholder="0.00"
                            className={`mt-1 form-control ${touched.amount && errors.amount ? "is-invalid" : ""}`}
                          />
                          <ErrorMessage component="div" name="amount" className="invalid-feedback" />
                        </div>
                      </div>
                    </div>

                    <div className="d-flex mt-4 pt-4 border-top">
                      <button
                        style={{ width: "110px" }}
                        type="submit"
                        className="btn btn-primary mr-2"
                        disabled={buttonLoader}
                      >
                        <div className="d-flex align-items-center justify-content-center">
                          <b>Submit</b>
                          {buttonLoader && (
                            <div className="spinner-border ml-2" role="status" style={{ height: "16px", width: "16px" }} />
                          )}
                        </div>
                      </button>
                      <button
                        style={{ width: "110px" }}
                        onClick={() => setShowPage(false)}
                        type="button"
                        className="btn btn-secondary ms-2"
                      >
                        Cancel
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </Box>
          </div>
        </div>
      ) : (
        <div className="content p-3">
          <div class="card " style={{ overflow: "scroll" }}>
            <div
              class="pl-4 pr-4 pt-4"
              style={{ display: "flex", justifyContent: "" }}
            >
              {accessObject?.coinPackageAdd == true && (
                <>
                  <button
                    style={{ width: "118px" }}
                    onClick={() => {
                      openAddTournament(1);
                    }}
                    type="button"
                    className="btn btn-primary btn-block "
                  >
                    <AddIcon />
                    Add New
                  </button>
                </>
              )}

              {/* <div>
                <input
                  class="input-simple"
                  type="text"
                  placeholder="Search Email..."
                  value={searchSubType}
                  onChange={(e) => setSearchTourName(e.target.value)}
                />
              </div> */}
            </div>

            <div class="card-body">
              <table id="" class="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th>SrNo</th>
                    <th>Date</th>
                    <th>Name</th>
                    <th>Coin</th>
                    <th>Bonus</th>
                    <th>Amount</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {accessObject?.getCoinPackageList == true ? (
                    <>
                      {!loader ? (
                        <>
                          {searchingData.length > 0 ? (
                            <>
                              {searchingData
                                .reverse()
                                ?.slice(pagination.start, pagination.end)
                                .map((item, index) => (
                                  <>
                                    <tr key={index}>
                                      <td>{index + 1 + pagination.start}</td>
                                      <td>
                                        {moment(item.createdAt).format(
                                          "DD/MM/YYYY"
                                        )}
                                      </td>
                                      <td>{item.name}</td>
                                      <td>{item.coin}</td>
                                      <td>{item.bonus}</td>
                                      <td>{item.amount}</td>
                                      <td>{item.status}</td>
                                      <td className="d-flex justify-content-evenly ">
                                        <EditIcon
                                          className="mr-3 courser"
                                          onClick={() => clickEditButton(item)}
                                        />
                                        <ClearIcon
                                          className="courser text-danger"
                                          onClick={() =>
                                            warningWithConfirmMessage(item)
                                          }
                                        />
                                      </td>
                                    </tr>
                                  </>
                                ))}
                            </>
                          ) : (
                            <EmptyState colSpan={8} />
                          )}
                        </>
                      ) : (
                        ""
                      )}
                    </>
                  ) : (
                    <>
                      <tr>
                        <td colSpan={14} className="p-3">
                          <h5 className="text-center mb-0">Access Denied</h5>
                        </td>
                      </tr>
                    </>
                  )}
                </tbody>
              </table>
              {accessObject?.getCoinPackageList == true && (
                <div className="mt-4">{loader && <Loader />}</div>
              )}
            </div>
            {searchingData.length != 0 && (
              <Pagination
                showPrePage={showPrePage}
                onPaginationChange={onPaginationChange}
                total={searchingData.length}
              />
            )}
          </div>
        </div>
      )}
    </>
  );
}
